<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     费用中心-订单管理-订单列表
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="expense-order mb-md">
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item">
          <f-radio-btn-group v-model="query.pay_status" :groups="status" @change="fetchData(1)" />
        </div>
        <div class="filter-item">
          <f-date-range-picker v-model="query.createtime" :shortcuts="[0, -7, -30, -90]" @change="fetchData(1)" />
        </div>
        <div class="filter-item" style="width: 240px">
          <el-input v-model="query.keyword" placeholder="订单号 / 主题" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
        </div>
      </div>
    </div>

    <el-card v-if="list.length > 0" v-loading="loading" shadow="never">
      <el-row class="text-muted" :gutter="20" style="padding: 0 20px 10px 20px;">
        <el-col :span="12">
          <el-checkbox v-model="checked" :indeterminate="isIndeterminate" @change="handleChange"></el-checkbox>
          <span class="ml">商品</span>
        </el-col>
        <el-col :span="4" class="text-center">金额</el-col>
        <el-col :span="4" class="text-center">状态</el-col>
        <el-col :span="4" class="text-center">交易操作</el-col>
      </el-row>
      <div v-for="(order, index) in list" :key="index" class="order-card">
        <div class="order-header">
          <span class="mr">
            <el-checkbox v-model="order.checked" @change="changeItem(order)" :disabled="order.pay_status !== 0"></el-checkbox>
          </span>
          <b>{{ order.createtime | parseTime('{y}/{m}/{d}') }}</b>
          <span class="span font-sm">订单号： {{ order.order_sn }}</span>
        </div>
        <div class="order-body">
          <el-row :gutter="20">
            <el-col :span="12">
              <f-image class="thumb" :src="order.thumb" />
              <div class="content">
                <router-link :to="'/expense/order/detail?orderid=' + order.orderid">{{ order.subject }}</router-link>
                <div class="order-tag-area mt-xs">
                  <div v-for="(tag,tagIndex) in order.order_tags" :key="tagIndex" class="tag mr-sm" >
                    {{ tag }}
                  </div>
                </div>
                <ul class="feature" :class="order.order_tags.length > 0 ? 'feture-mt-sm' : ''">
                  <li v-if="order.order_type === 1" title="新购">新</li>
                  <li v-if="order.order_type === 2" title="续费">续</li>
                  <li v-if="order.order_cateid === 2" title="云产品" class="blue">云</li>
                  <li v-if="order.order_cateid === 3" title="研发服务" class="blue">研</li>
                  <li v-if="order.referer === 0" title="该订单由销售人员代创建">代</li>
                  <li v-if="order.pay_type === 3" title="该订单月结货款" class="warning">月</li>
                </ul>
              </div>
            </el-col>

            <el-col :span="4" class="text-center">
              <div class="vspan">
                <strong>总额： {{ order.order_amount_total | currency }}</strong>
              </div>
              <div class="vspan">
                <span class="text-muted font-sm">（含运费： {{ order.express_fee | currency }}）</span>
              </div>
            </el-col>

            <el-col :span="4" class="text-center">
              <div class="vspan" :class="{ 'text-warning': order.pay_status === 0 || order.pay_status === 2 }">{{ payStatusObj[order.pay_status] }}</div>
              <div class="vspan" :class="{ 'text-warning': order.shipping_status !== 3 }">{{ shippingStatusObj[order.shipping_status] }}</div>
            </el-col>

            <el-col :span="4" class="text-center">
              <div v-if="order.pay_status === 0" class="vspan">
                <el-button type="primary" size="small" @click="toCashier(order)">去付款</el-button>
              </div>
              <div class="vspan text-primary">
                <router-link :to="'/expense/order/detail?orderid=' + order.orderid">查看订单</router-link>
              </div>
              <div v-if="order.pay_status === 1 && !order.invoiced" class="vspan text-primary">
                <router-link :to="'/expense/invoice/apply'">申请开票</router-link>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="flex align-items-center justify-content-space-between">
        <div class="ml">
          <el-checkbox v-model="checked" :indeterminate="isIndeterminate" @change="handleChange"></el-checkbox>
          <el-button type="primary" size="small" @click="mergePay()" :disabled="checkedItems.length === 0" class="ml">合并付款</el-button>
        </div>
        <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
      </div>
    </el-card>
    <el-card v-else v-loading="loading" shadow="never">
      <div class="flex-center column pb-md">
        <div class="flex-center mt-hg">
          <img src="../../assets/no-data.png" alt class="no-data" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getOrderListApi } from "@/api/expense/expenseOrderApi";
export default {
  name: "ExpenseOrder",
  components: {},
  data() {
    return {
      loading: false,
      query: {
        pay_status: this.$route.query.pay_status
          ? this.$route.query.pay_status
          : -10,
        createtime: null,
        keyword: "",
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
      },
      status: [
        { value: -10, title: "全部", separate: true },
        { value: 0, title: "待付款" },
        { value: 2, title: "付款中" },
      ],
      total: 0,
      list: [],
      tableSelection: [],

      checked: false,
      checkedItems: [],
      isIndeterminate: false,
    };
  },
  computed: {
    payStatusArr() {
      return this.$store.state.expenseStore.payStatusArr;
    },
    payStatusObj() {
      return this.$store.getters.payStatusObj;
    },
    shippingStatusObj() {
      return this.$store.getters.shippingStatusObj;
    },
  },
  watch: {
    'query.pay_status': function (val) {
      this.checked = false;
    },
    checkedItems(val) {
      const tempArr = this.list.filter((item) => {
        return item.pay_status === 0;
      });
      this.isIndeterminate = val.length > 0 && val.length < tempArr.length;
    }
  },
  created() {
    const keepAlivePath = ["/expense/order/detail"];
    this.query = this.$utils.initListQuery(this.query, keepAlivePath);
    this.fetchData();
  },
  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.query);
    next();
  },
  methods: {
    fetchData(page) {
      if (page) this.query.pindex = page;
      this.loading = true;
      getOrderListApi(this.query).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.list = res.data.list;
          if (this.list.length) {
            this.list = this.list.map((item) => {
              if (item.order_tags.length) {
                item.order_tags = item.order_tags.filter(e => e != '');
              }
              const obj = Object.assign({}, item, {
                checked: false,
              });
              return obj;
            });
          }

          this.total = res.data.total;
        }
      });
    },
    toCashier(order) {
      this.$router.push("/expense/order/cashier");
      localStorage.setItem("__ORDERID__", order.orderid);
    },

    mergePay() {
      const orderids = this.checkedItems.map((item) => {
        return item.orderid;
      })
      this.$router.push("/expense/order/cashier?type=merge");
      localStorage.setItem("__ORDERIDS__", orderids);
    },

    handleChange() {
      if (this.checked) {
        this.list.forEach((item) => {
          if (item.pay_status === 0) item.checked = true;
        });
      } else {
        this.list.forEach((item) => {
          item.checked = false;
        });
      }
      this.checkedItems = this.list.filter((item) => {
        return item.checked
      });
    },
    changeItem(order) {
      const tempArr = this.list.filter((item) => {
        return item.pay_status === 0;
      });
      if (tempArr.every((v) => v.checked)) {
        this.checked = true;
      } else {
        this.checked = false;
      }
      this.checkedItems = this.list.filter((item) => {
        return item.checked
      });
    },
  },
};
</script>

<style lang="scss" slot-scoped>
.expense-order {
  .order-card {
    margin-bottom: 20px;
    border: 1px solid #ebeef5;
    .order-header {
      background-color: #f5f7fa;
      line-height: 40px;
      padding: 0 20px;
    }
    .order-body {
      padding: 20px;
      .thumb {
        width: 80px;
        height: 80px;
        vertical-align: top;
      }
      .content {
        display: inline-block;
        margin-left: 20px;
        .feature {
          margin-top: 20px;
          padding-left: 0px;
          &.feture-mt-sm {
            margin-top: 10px;
          }
          li {
            display: inline-block;
            margin-right: 8px;
            background-color: #07c160;
            color: #fff;
            line-height: 22px;
            width: 22px;
            text-align: center;
            border-radius: 4px;
            font-size: 12px;
            &.danger {
              background-color: #e64340;
            }
            &.warning {
              background-color: #f0ad4e;
            }
            &.blue {
              background-color: #409eff;
            }
          }
        }
      }
      .order-tag-area {
        display: flex;
        align-items: center;
        .tag {
          height: 20px;
          line-height: 20px;
          border-radius: 4px;
          // background-color: rgba(242, 150, 25, 1);
          background: linear-gradient(91.06deg, rgba(254,167,44,1) 3.04%,rgba(253,120,34,1) 101.6%);
          color: rgba(255, 255, 255, 1);
          font-size: 12px;
          text-align: center;
          font-style: italic;
          padding: 0 10px;
          font-weight: 700;
        }
      }
    }
  }
}
</style>
